import React from 'react';
import PropTypes from 'prop-types';
import css from './InstructionsToUse.module.css';
import ReactPlayer from 'react-player';
import { isHTMLString } from '../../../util/data';

const InstructionsToUse = ({ content }) => {
    const { text, video } = typeof content === 'object' ? content : { text: content, video: null };
  
    return (
      <section className={css.panel} aria-labelledby="instructions-heading">
        <h3 id="instructions-heading" className={css.heading}>
          Instructions to Use
        </h3>
  
        <article className={css.content}>
          {/* Fallback to pre for plain text, otherwise HTML */}
          {text ? (
            isHTMLString(text) ? (
              <div dangerouslySetInnerHTML={{ __html: text }} />
            ) : (
              <pre>{text}</pre>
            )
          ) : (
            <p>No instructions provided.</p>
          )}
        </article>
  
        {video?.playback_url && (
          <figure className={css.video}>
            <ReactPlayer
              url={video.playback_url}
              controls
              width="100%"
              height={414}
              style={{ borderRadius: 8, background: '#000' }}
            />
            <figcaption style={{ display: 'none' }}>Instructional video</figcaption>
          </figure>
        )}
      </section>
    );
  };
  

InstructionsToUse.propTypes = {
    content: PropTypes.string.isRequired,
};

export default InstructionsToUse; 